"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitLinkSidebx = function SubmitLinkSidebx(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$siteprefix = _ref.siteprefix,
      siteprefix = _ref$siteprefix === undefined ? "r" : _ref$siteprefix,
      subreddit = _ref.subreddit;
  return _react2.default.createElement(
    "div",
    { className: "spacer" },
    _react2.default.createElement(
      "div",
      { className: "sidebox submit submit-link" },
      _react2.default.createElement(
        "div",
        { className: "morelink" },
        _react2.default.createElement(
          Link,
          {
            className: "login-required access-required",
            "data-event-action": "submit",
            "data-event-detail": "link",
            "data-type": "subreddit",
            href: subreddit && subreddit !== "all" ? "/" + siteprefix + "/" + subreddit + "/submit" : "/submit"
          },
          "Submit a new link"
        ),
        _react2.default.createElement("div", { className: "nub" })
      )
    )
  );
};

exports.default = SubmitLinkSidebx;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/SubmitLinkSidebox.js
// module id = 325
// module chunks = 0